import { useQuery } from '@tanstack/react-query';

import { paymentsQueryKeys } from '../payments-qk';
import { PaymentsApi } from '../payments.api';

export const useGetPaymentMethod = ({ enabled }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: paymentsQueryKeys.paymentMethod(),
    queryFn: () => PaymentsApi.getPaymentMethod(),
    enabled,
  });
};
